module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAABEElEQVQ4jaXUvUpDMRgG4KflWBSkCh0cXKTg6qC4KZSKk5uLa4urOPozOKuT4NBNHQQRB6/CzT+8gup12MHh9MBR0rTHvlMSvjx8ISGlVqslkm1c9sf7eBxUmESQJVxhtj+/wRdeQ8XlwFoF1/jIIVDFC+4xNQp0inak0x1cDINq2IsgWXYxF4Oa0qMNS4JGDFocAclSj0EzBaBqDKoVgCZiUN3omR8EJVgtAK2jFIKamC7YUSMEnRRAshz/hdpY+we0KX2cEumROv9AsnTQLeMOk2NAFdyW0R0DydJNsCG99vwDW8EZDvDeX1vGOQ7xlqv9xnNpwA+Z4AkLfv+Qn9JL6YU2hNLDVq4DeMBRCIEfoNEmGISUjDoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_bell.png
// module id = SudZ
// module chunks = 1